module.exports = __webpack_public_path__ + "static/media/coupons-disabled.860cae5b.png";